import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appReleased]'
})
export class ReleasedDirective {

  constructor(element: ElementRef) {
    element.nativeElement.style.color = '#448691';
    element.nativeElement.style.fontWeight = 'bold';
  }

}
